import './VariableDetails.scss'
import TopSection from './TopSection/TopSection'
import FormSection from './FormSection/FormSection'
import Spinner from '../Spinner/Spinner'
import { useContext } from 'react'
import { UserActionContext } from '../../AppContext'
import { observer } from 'mobx-react'

type VariableDetailsProps = {
  selectedVariableId: number
  selectedVariableDetails: VariableDetail | undefined
  clearSelectedVariable: () => void
  isLoadingVariableDetails?: boolean
  isEditor: boolean
  detectUserAction: (userAction: string) => void
}

const VariableDetails = ({ selectedVariableDetails, clearSelectedVariable, isLoadingVariableDetails, isEditor, detectUserAction }: VariableDetailsProps) => {

  //#region TODO: This is temporary until Role implementation and after role implementation needs to remove this
  const { action, setAction } = useContext(UserActionContext);

  return (
    <>

      {isLoadingVariableDetails ? <Spinner /> :
        <>
          <TopSection
            selectedVariableDetails={selectedVariableDetails}
            clearSelectedVariable={clearSelectedVariable}
            isEditor={isEditor}
            action={action}
            setAction={(action: string) => setAction(action)}
            onUserAction={detectUserAction} />
          <FormSection
            selectedVariableDetails={selectedVariableDetails}
            isEditor={isEditor}
          />
        </>
      }
    </>
  )
}

export default  observer(VariableDetails)
